module.exports = __webpack_public_path__ + "img/yaoshi-gaoji.8828de2c.png";